import { CompanyMembers } from '@/features/company-members/components/CompanyMembers';

export function CompanyMembersPage() {
  return <CompanyMembers />;
}

export default CompanyMembersPage;
